import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { type TranscriptCueElement } from '../../types/aha-editor';
import { type Descendant } from 'slate';
import { isHTMLElementNode } from '../helpers/serializerHelpers';
import { isTranscriptCueElement } from '../../types/guards';

class SerializerTranscriptCue extends Serializer {
  static deserialize({
    el,
    next,
    markAttributes,
  }: DeserializeArguments): TranscriptCueElement | Descendant[] | undefined {
    if (
      !isHTMLElementNode(el) ||
      el.tagName.toLowerCase() !== 'span' ||
      el.getAttribute('data-aha-editor-type') !== 'transcript-cue'
    )
      return;

    return {
      type: 'transcript-cue',
      cue_startTime:
        parseInt(
          el.getAttribute('data-transcript-cue-start-time') || '0',
          10
        ) || 0,
      cue_endTime:
        parseInt(el.getAttribute('data-transcript-cue-end-time') || '0', 10) ||
        0,
      children: next(el.childNodes, markAttributes),
    };
  }

  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!isTranscriptCueElement(node)) return;

    const { cue_startTime, cue_endTime } = node;

    return (
      <span
        data-aha-editor-type="transcript-cue"
        data-transcript-cue-start-time={cue_startTime}
        data-transcript-cue-end-time={cue_endTime}
      >
        {children}
      </span>
    );
  }
}

export default SerializerTranscriptCue;
